export default {
  ConditionalReturn: {
    CustomerProfile: 'پروفایل مشتری',
    OpenInventory: 'باز کردن همین کد در مخزن محصول',
    InvoiceAction: 'مرجوعی مشروط',
    NotificationHeading: 'بررسی سلامت کدهای مرجوعی',
    OpenNotifiedCase: 'باز کردن پروندهٔ {id} و بررسی کد',

    SettlementExplanation: 'مبلغ {amount} در {date} به کیف پول مشتری برگشت داده شد. این پرونده تسویه شده است.',
    ProgressLabel: 'پیشرفت: {confirmed} از {total}',
    ChooseCase: 'انتخاب پرونده',
    NewReturn: 'ثبت مرجوعی جدید',
    PartialHint: 'انتخاب چند قلم یا بخشی از تعداد یک ردیف',
    ProductRefund: 'مبلغ قابل‌برگشت (فقط محصولات)',
    ProgressSteps: 'مراحل مرجوعی',
    StageCreated: 'ثبت مرجوعی',
    StageResold: 'فروش مجدد',
    StageHealth: 'تأیید سلامت',
    StageWallet: 'شارژ خودکار کیف پول',
    BlockNotice: 'مشتری تا تسویه نهایی این مرجوعی مسدود است',
    BlockExplanation: 'این مسدودی فقط مربوط به همین مرجوعی است و سایر محدودیت‌های کاربر مستقل باقی می‌مانند.',
    SettledNotice: 'مبلغ محصولات به کیف پول مشتری برگشت داده شد',
    OtherBlocksRemain: 'محدودیت این مرجوعی برداشته شد؛ پرونده‌های باز دیگر و مسدودی‌های مستقل همچنان معتبرند.',
    ConfirmedCount: '{confirmed} از {total} کد تأیید شده است.',
    AutoRefundExplanation: 'پس از فروش مجدد همه کدها و تکمیل تأیید سلامت آن‌ها، مبلغ {amount} به‌صورت خودکار به کیف پول مشتری برمی‌گردد.',
    ReturnedProduct: 'محصول مرجوع‌شده',
    ReturnedCount: 'تعداد مرجوعی: {count} کد',
    InvoiceQuantity: 'در کل فاکتور: {count} قلم',
    ReturnCreatedBy: 'ثبت‌کننده مرجوعی',
    ApprovalPlaceholder: 'دلیل خود را برای تأیید سلامت این کد وارد کنید…',
    LastApprovalHint: 'پس از آخرین تأیید، وجه خودکار به کیف پول برمی‌گردد.',
    Events: 'رویدادهای پرونده',
    Toman: 'تومان',
    ExcludedFees: 'کارمزد، مالیات و هزینه ارسال قابل‌برگشت نیستند.',
    BankFee: 'کارمزد بانکی',
    Tax: 'مالیات',
    Shipping: 'هزینه ارسال',
    NonRefundable: 'قابل‌برگشت نیست.',
    SettledTitle: 'مرجوعی با موفقیت تسویه شد',
    WaitingTitle: 'در انتظار فروش مجدد کدها',
    OneApprovalLeft: 'فقط یک تأیید تا تسویه',
    ReviewTitle: 'بررسی سلامت کدهای مرجوعی',
    InventoryReturned: 'بازگشت به موجودی',
    ResoldCode: 'فروش مجدد کد {id}',
    ApprovedCode: 'تأیید سلامت کد {id}',
    BackToList: 'بازگشت به فهرست',
    ListDescription: 'فروش مجدد، تأیید سلامت و تسویه پرونده‌ها را پیگیری کنید.',
    Status: 'وضعیت',
    NoReturns: 'پرونده‌ای با این وضعیت وجود ندارد.',
    UserBlocked: 'حساب به دلیل مرجوعی مشروط مسدود است؛ رفع این محدودیت پس از تسویه همه پرونده‌های باز انجام می‌شود.',
    Title: 'مرجوعی مشروط به فروش مجدد',
    Refresh: 'به‌روزرسانی',
    Help: 'اقلام یا بخشی از تعداد یک ردیف را انتخاب کنید. کدها به مخزن برمی‌گردند و حساب مشتری تا تسویه مسدود می‌ماند. مبلغ با احتساب تخفیف خرید و بدون کارمزد، ارسال و مالیات محاسبه می‌شود. اقلام دیگر فاکتور حفظ می‌شوند.',
    LoadFailed: 'دریافت اطلاعات ناموفق بود؛ دوباره به‌روزرسانی کنید.',
    Create: 'ثبت و تأیید مرجوعی مشروط',
    Code: 'شناسه کد',
    Reason: 'دلیل',
    ConfirmCreate: 'با تأیید، {count} کد انتخاب‌شده به مخزن برگشته و حساب مشتری مسدود می‌شود؛ فعلاً وجهی برنمی‌گردد.',
    Case: 'پرونده',
    Settled: 'تسویه شده',
    Pending: 'در انتظار تسویه',
    Amount: 'مبلغ قابل‌برگشت',
    CreatedBy: 'ثبت و تأیید مرجوعی توسط',
    SettledAt: 'زمان تسویه',
    IRR: 'ریال',
    USD: 'دلار',
    Confirmed: 'سلامت تأیید شده',
    AwaitingApproval: 'فروش مجدد؛ در انتظار تأیید سلامت',
    AwaitingResale: 'در انتظار فروش معتبر یا رفع مشکل',
    ResaleBill: 'شناسه فاکتور فروش مجدد',
    ApprovedBy: 'تأیید سلامت توسط',
    Approve: 'تأیید سلامت کد',
    ApprovalReason: 'دلیل و مستند تأیید سلامت',
    ApprovalHelp: 'تأیید کنید کد در فروش مجدد سالم بوده است. پس از تأیید همه کدهای این پرونده، وجه خودکار به کیف پول برمی‌گردد و مسدودی همین مرجوعی برداشته می‌شود.',
    Empty: 'کد قابل‌مرجوعی یا پرونده‌ای وجود ندارد.',
    ReasonRequired: 'دلیل بین ۳ تا ۲۰۰۰ نویسه الزامی است.',
    Index: 'مرجوعی‌های مشروط',
    Bill: 'شماره فاکتور',
    Open: 'بررسی پرونده',
    All: 'همه',
    SelectBill: 'یک پرونده را برای بررسی انتخاب کنید.',
  },
  Bills: {
    Modal: {
      Title: 'فاکتور شماره _BILL_NUMBER_',
    },
    Status: {
      0: 'در حال پردازش',
      1: 'تحویل داده شده',
      2: 'در حال پردازش باقی مانده',
      3: 'لغو شده',
      4: 'احراز نشده',
    },
    AuthLabel: {
      0: ' ندارد ',
      1: ' مجاز ',
      2: ' دارد ',
    },
    DeliveryTime: 'مدت زمان تحویل',
    DeliveryImmediate: 'آنی',
  },
}
